import didomi from '@/scripts/didomi'
import useDidomi from '@/composables/didomi/useDidomi'

const EXCLUDED_PATHS = [
  '/formularze/marketing/oferta',
  '/formularze/marketing/oferta/dziekujemy',
]

export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp()
  const route = useRoute()

  if (EXCLUDED_PATHS.includes(route.path)) {
    return
  }

  const {
    setDidomiLanguage,
  } = useDidomi()

  setDidomiLanguage($i18n.locale.value)
  didomi()
})
